import { useState } from "react";
import { Bell, CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function NotifyButton({ product, testid }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const email = new FormData(e.target).get("email");
    setBusy(true);
    try {
      await api.post("/notify", { email, product_id: product.id });
      setDone(true);
      toast.success("Tu seras prévenue dès son retour !");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  if (done) {
    return (
      <p className="mt-3 flex items-center justify-center gap-2 text-xs font-semibold text-kay-green" data-testid={`${testid}-done`}>
        <CheckCircle2 size={14} /> Alerte activée — vérifie ta boîte mail
      </p>
    );
  }
  if (open) {
    return (
      <form onSubmit={submit} className="mt-3 flex gap-1.5" data-testid={`${testid}-form`}>
        <input
          name="email"
          type="email"
          required
          defaultValue={user?.email || ""}
          placeholder="Ton email"
          className="flex-1 min-w-0 rounded-full border border-kay-line bg-white px-3.5 py-2 text-xs outline-none focus:border-kay-pink"
          data-testid={`${testid}-email`}
        />
        <button type="submit" disabled={busy} className="rounded-full bg-kay-ink text-white px-4 py-2 text-xs font-bold hover:bg-kay-pink transition-colors disabled:opacity-50" data-testid={`${testid}-submit`}>
          {busy ? <Loader2 size={13} className="animate-spin" /> : "OK"}
        </button>
      </form>
    );
  }
  return (
    <button
      type="button"
      data-testid={testid}
      onClick={() => setOpen(true)}
      className="mt-3 w-full rounded-full border border-kay-pink text-kay-pink py-2.5 text-sm font-semibold flex items-center justify-center gap-2 hover:bg-kay-pink hover:text-white transition-all"
    >
      <Bell size={14} /> Me prévenir du retour
    </button>
  );
}
